import { useNavigate, useParams } from "react-router-dom";
import { useData } from "./useData";
import { PropertyRepository } from "@/repositories/PropertyRepository";
import type { PropertyWithStaysProperty } from "@/types";

const propertyRepository = new PropertyRepository();

interface UsePropertyFormPageReturn {
  property: PropertyWithStaysProperty | null;
  isEditing: boolean;
  loading: boolean;
  error: Error | null;
  handleSuccess: () => void;
  handleCancel: () => void;
}

export function usePropertyFormPage(): UsePropertyFormPageReturn {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isEditing = Boolean(id);

  const {
    data: property,
    isLoading: loading,
    error,
  } = useData<PropertyWithStaysProperty>({
    repository: propertyRepository,
    fetcher: (repo) => repo.getById(id!),
    queryKey: ["property", id || ""],
    options: {
      enabled: isEditing && !!id,
    },
  });

  const handleSuccess = () => {
    navigate("/properties");
  };

  const handleCancel = () => {
    navigate("/properties");
  };

  return {
    property: (property as PropertyWithStaysProperty) || null,
    isEditing,
    loading,
    error,
    handleSuccess,
    handleCancel,
  };
}
